import { orchestrator } from 'satcheljs';
import { lazyRemoveConnectedAccount } from 'owa-link-account';
import { trace } from 'owa-trace';
import { lazyRemoveOWAConnectedAccount } from 'owa-account-store-init';
import {
    connectedAccountDisconnected,
    disconnectOWAConnectedAccountFailed,
    disconnectOWAAccount,
} from '../actions/publicActions';

orchestrator(disconnectOWAAccount, async ({ account, isReconnectFlow }) => {
    if (
        account.accountProviderType == 'Outlook' ||
        account.accountProviderType == 'Google' ||
        account.accountProviderType == 'ICloud' ||
        account.accountProviderType == 'Yahoo'
    ) {
        const response = await lazyRemoveConnectedAccount.importAndExecute(account.accountId);

        if (response.status == 204) {
            // once disconnected, remove it from local client store
            lazyRemoveOWAConnectedAccount.importAndExecute(account.userIdentity);

            // Announce account disconnected so that we can fire the accountRemoved action
            connectedAccountDisconnected(account.userIdentity, isReconnectFlow);
        } else {
            trace.warn(`Failed to remove account ${account.userIdentity}`);
            disconnectOWAConnectedAccountFailed(isReconnectFlow);
        }
    } else {
        throw new Error(
            `${account.accountProviderType} provider is not yet supported for OWA Calendar`
        );
    }
});
